/**
 * CheckBox.js
 * Created by calhosh on 11/3/2020.
 */
import React from 'react';
import {EllipseControl} from '@ey/canvascoreservices';
import styled from 'styled-components';
import MotifCheckbox from '@ey/motif-react-wrapper/Checkbox';

export default function CheckBox(props) {
	const {
		label,
		name,
		title,
		value,
		checked,
		disabled,
		dataAutoID,
		ellipse,
		inline,
		noOfLines,
		styleName,
		className,
		customElement,
		statusLabel,
		id,
		onChange
	} = props;
	return (
		<Wrapper className={styleName ? styleName : ''}>
			<MotifCheckbox
				id={id}
				name={name}
				inline={inline}
				value={value}
				title={title}
				onChange={onChange}
				checked={checked}
				disabled={disabled}
				className={className}
				data-autoid={dataAutoID}
			>
				{customElement && customElement}
				{ellipse ? (
					<EllipseControl content={label} id={name} tooltip={label} displayId={props.displayId} noOfLines={noOfLines} />
				) : (
					<span htmlFor={id} title={label} className="checkboxLabel">
						{label}
					</span>
				)}
				{statusLabel && <span className="statusLabel">{statusLabel}</span>}
			</MotifCheckbox>
		</Wrapper>
	);
}

const Wrapper = styled.span`
	display: inline-block;
	position: relative;
	vertical-align: top;
	.motif-checkbox {
		.motif-checkbox-input {
			opacity: 0;
			z-index: 999;
			left: 0;
			top: var(--px-3);
			position: absolute;
			margin: 0;
		}
		.motif-checkbox-label {
			width: 75%;
		}
	}
`;
